// src/services/airtable.js
const fetchEvents = async () => {
    const apiKey = 'patEd29pSg8LnL36l.eb35a655cc8e8ba3bcdeaa6d80a32b93122933545861ae7b1d7c285ef41110ec';
    const baseId = 'app4j5h7jZXu3QLxj';
    const tableName = 'Events';
  
    try {
      const response = await fetch(`https://api.airtable.com/v0/${baseId}/${tableName}`, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error fetching events: ${response.statusText}`);
      }
  
      const data = await response.json();
      return data.records.map(record => ({
        id: record.id,
        title: record.fields['Event Name'],
        start: new Date(record.fields['Start Date']),
        end: new Date(record.fields['End Date']),
        location: record.fields['Event Location'], // Added field
        description: record.fields['Event Description'], // Added field
      }));
    } catch (error) {
      console.error(error);
      return [];
    }
  };
  
  export { fetchEvents };
  